export default __webpack_public_path__ + "static/media/add2.32493a41.png";